import { atomFamily } from 'jotai/utils';
import { UnUploadedImage } from 'components/PhotoUpload/types';
import { createDerivedSessionAtom } from './utils/createDerivedSessionAtom';
import { createPersistedAtom } from './utils/createPersistedAtom';

export const sessionSignatureImageAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage | null>(`signatureImage-${sessionId}`, null)
);

export const signatureImageAtom = createDerivedSessionAtom<UnUploadedImage | null>(sessionSignatureImageAtom);